import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromLogbookCatches from './logbook-catches.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromLogbookCatches.logbookCatchesFeatureKey,
      fromLogbookCatches.reducer
    ),
  ],
})
export class LogbookCatchesModule {}
